// extracted by mini-css-extract-plugin
module.exports = {"expandContentButton":"styles_expandContentButton__HoJwO","arrowIcon":"styles_arrowIcon__2zElE","text":"styles_text__1tRjO"};